import { useDispatch, useSelector } from "react-redux";
import { setSection } from "../../../../assignmentSlice";
import { typeInfo } from "../../../../../../constants/typeInfo";
import UserInputBar from "../../../widgets/UserInputBar";

const SummaryBlankPage = ({
  pageList,
  currentPage,
  currentIndex,
  userInput,
  selectedBlankIndex,
  setPageList,
  setUserInput,
  setSelectedBlankIndex,
}) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const selectedBlank = currentPage.question.find(
    (element) =>
      element.index === selectedBlankIndex && element.type === "blank"
  );

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const changeSelectedBlank = (element) => {
    if (element.isSubmitted) return alert("이미 정답 제출한 빈칸입니다.");
    setSelectedBlankIndex(element.index);
    currentPage.question.forEach((question) => {
      if (question.type === "blank") {
        if (question.index === element.index) {
          setUserInput(question.input);
        }
      }
    });
  };

  const handleSetAnswer = () => {
    const nextElement = currentPage.question
      .filter(
        (element) => element.type === "blank" && element.isSubmitted === false
      )
      .find((element) => element.index > selectedBlankIndex);
    if (nextElement) {
      changeSelectedBlank(nextElement);
    }

    let isSumbitted = true;
    const question = [];
    currentPage.question.forEach((element) => {
      if (element.type === "blank") {
        if (element.index === selectedBlankIndex) {
          question.push({ ...element, input: userInput });
        } else {
          if (element.input === "") {
            isSumbitted = false;
          }
          question.push(element);
        }
      } else {
        question.push(element);
      }
    });

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          question: question,
          isSubmitted: isSumbitted,
        };
      }
      return prevPage;
    });

    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
        width: "90%",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          marginBottom: "20px",
        }}
      >
        {"빈칸을 채우세요."}
      </div>
      <div
        style={{
          fontSize: "28px",
        }}
      >
        {currentPage.question.map((element, index) => {
          if (element.type === "text") {
            return element.content;
          } else if (element.type === "blank") {
            const userAnswer = element.input;
            const blankLength = element.length;
            const isSelected = element.index === selectedBlankIndex;

            return (
              <span
                key={index}
                onClick={() => changeSelectedBlank(element)}
                style={{
                  display: "inline-block",
                  minWidth: 20,
                  marginRight: 4,
                  marginLeft: 4,
                  cursor: "pointer",
                  letterSpacing: userAnswer === "" ? "0" : null,
                  backgroundColor: isSelected
                    ? typeInfo["comprehensive"].backgroundColor
                    : userAnswer === ""
                    ? "transparent"
                    : "#EBEBEB",
                }}
              >
                <span
                  style={{
                    color: typeInfo["comprehensive"].color,
                  }}
                >
                  {element.hint}
                </span>
                {userAnswer || "_".repeat(blankLength)}
              </span>
            );
          }
          return null;
        })}
      </div>
      <div style={{ position: "relative", width: "60%", marginTop: "50px" }}>
        <UserInputBar
          handleSetAnswer={handleSetAnswer}
          handleChange={handleChange}
          userInput={userInput}
          type={"comprehensive"}
          onlyUnderline={true}
          isSubmitted={selectedBlank.input !== ""}
          hint={selectedBlank.hint}
        />
      </div>
    </div>
  );
};

export default SummaryBlankPage;
